module.exports = __webpack_public_path__ + "static/media/scholarUnlocked.7a2d309f.png";